import { render, staticRenderFns } from "./BerlianTersediaView.vue?vue&type=template&id=622ecee0&scoped=true&"
import script from "./BerlianTersediaView.vue?vue&type=script&lang=js&"
export * from "./BerlianTersediaView.vue?vue&type=script&lang=js&"
import style0 from "./BerlianTersediaView.vue?vue&type=style&index=0&id=622ecee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622ecee0",
  null
  
)

export default component.exports